import { UI, Stack } from '@genial/components';
import { RouteProp, useRoute } from '@react-navigation/native';
import React from 'react';

import { CustomerDetailStackParamList } from '../../../../../../routes/types';
import { DynamicAsset } from '../../../../../BatchTicket/components/DynamicAsset';
import {
  allProductsConstants,
  getAllProductsEnabled,
} from '../../../../../BatchTicket/components/DynamicAsset/constants';
import { GlobalAssetContextReceivedData } from '../../../../../BatchTicket/components/DynamicAsset/contexts';
import { DynamicAssetLoading } from '../../../../../BatchTicket/components/DynamicAssetLoading';
import { useCustomer } from '../../hooks/useCustomer';
import { DynamicButton } from '../DynamicButton';

export interface DynamicAssetProps {
  infoGetter: GlobalAssetContextReceivedData['infoGetter'];
  CustomGlobalButton?: React.FC;
}

export const DynamicAssetWrapper = () => {
  const { params } = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();
  const { customerData, customerDataIsLoading } = useCustomer(params.accountNumber);

  const productsEnabled = getAllProductsEnabled([...allProductsConstants], 'unleashFlagCustomers');

  if (customerDataIsLoading) {
    return <DynamicAssetLoading />;
  }

  if (!productsEnabled.length) {
    return (
      <Stack py="stack.huge">
        <UI.ErrorBoundary
          errorIconOrIllustration="NotEmptyIllustration"
          errorIconColor="brand.tertiary.principal"
          errorTitle="Nenhum produto disponível no momento"
          errorMessage="Caso tenha dúvidas, entre em contato com time de middle pelo e-mail middleb2b@genial.com.vc"
        />
      </Stack>
    );
  }

  return (
    <DynamicAsset
      isBatchTicket={false}
      initialTabs={productsEnabled}
      accountId={params.accountId}
      document={params.customer?.cpfCnpjText || params.cpfCnpj.toString()}
      accountNumber={params.accountNumber}
      checkingAccountNumber={customerData?.data?.checkingAccountNumber}
      infoGetter={() => {
        return {
          Button: DynamicButton,
        };
      }}
    />
  );
};
